import Navigation from './navigation';
const Layout = ({ children }) => {
  return (
    <div className="font-sans leading-normal tracking-normal">
    {children}
    </div>
  );
};

export default Layout;